import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { BASE_URL } from '../config/config';
import { NgxSpinnerService } from "ngx-spinner"; 
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  public API_URL = BASE_URL.URL;

  constructor(
    private http: HttpClient, 
    private spinnerService: NgxSpinnerService, 
    private route: Router
  ) { 

  }

  getStocks(counts: Array<string> = []): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.API_URL}/analytics/stores/stocks?counts=${counts}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getConsumed(groupBy: string, interval: string = "", productType: string = ""): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.API_URL}/analytics/stores/consumed?group_by=${groupBy}&interval=${interval}&product_type=${productType}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getMissing(groupBy: string = ""): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.API_URL}/analytics/stores/missing?group_by=${groupBy}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getExpired(groupBy: string = ""): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.API_URL}/analytics/stores/expired?group_by=${groupBy}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getStores(warehouseId: string|number, fields: Array<string> = [], counts: Array<string> = []): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.API_URL}/stores?warehouse_id=${warehouseId}&fields=${fields}&counts=${counts}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getExpiring(groupBy: string = ""): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.API_URL}/analytics/stores/expiring?group_by=${groupBy}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  private handleError(error: any){
    if (error.status === 401) {
      localStorage.clear();
      this.route.navigateByUrl(`/login?redirect_link=${this.route.url}`);
      this.spinnerService.hide();
      return
    }else{
      this.spinnerService.hide();
      return throwError(()=> error);
    }

  }
}
